module.exports = __webpack_public_path__ + "static/media/delete.fc42c2d5.svg";